export default __webpack_public_path__ + "static/media/Green0006.bc44650b.png";